// @ts-nocheck
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { actions as advisersActions } from "../../modules/advisersModule"
import { actions as appActions } from "../../modules/appModule"
import { actions as commonActions } from "../../modules/commonModule"
import { actions as favActions } from "../../modules/favouritesModule"
import { actions as lseActions } from "../../modules/lseModule"
import { actions as newsActions } from "../../modules/newsModule"
import { actions as searchActions } from "../../modules/searchModule"
import { actions as synopsisActions } from "../../modules/synopsisModule"

import Navbar from "../../components/layout/DashboardNavbar"
import HomePageTabs from "../../components/HomePageTabs"
import TitleBar from "../../components/layout/TitleBar"
import MainSection from "../../components/layout/MainSection"
import DataCard from "../../components/layout/DataCard"
import NexusMenu from "../../components/layout/NexusMenu"
import NexusAdviserClientsTable from "../../components/layout/NexusTables/NexusAdviserClientsTable"
import MaxFavouritesReachedModal from "../../components/MaxFavouritesReachedModal"
import Footer from "../../components/Footer"

import getCheckboxMenu from "../../components/CheckboxMenus"
import { findCompaniesUsingAdviser } from "../../components/layout/NexusTables/NexusAdviserFunctions"
import { filterAdviserClientsByCheckbox } from "../../components/layout/FilterSearchResults"
import { LoadFavouritesAndLSEs } from "../../pages/home/helpers/loadFavouritesAndLSEs"
import { wouldExceedMaxCount } from "../../pages/home/helpers/homeFunctions"

import { BASE, CARD, CATEGORY, JARGON, KIND, PATH, TAB, TABLE_BIT } from "../../modules/constants"
import { CHECKBOX } from "../../modules/checkbox_constants"
import history from "../../services/history"

class AdviserPage extends Component {

  constructor(props) {
    super()
    this.state = {
      showMaxFavouritesReached: false,
    }
  }

  componentDidMount() {
    this.props.app.setPage(this.constructor.name)
    this.props.common.setTabIndex(TAB[BASE.COMPANY].INDEX)
    this.props.common.setCompanyTabUrl(this.props.match.url)
    LoadFavouritesAndLSEs(this.props)
  }

  handleSelect = link => {
    history.push(link)
  }

  handleOrderTable = props => {
    this.props.common.setTableOrder(props)
  }

  handleChangeCheckbox = ({ bit, hook }) => {
    const checkboxes = { ...this.props.checkboxes, [hook]: this.props.checkboxes[hook] ^ bit }
    if (this.props.isLoggedIn)
      this.props.common.saveCheckboxes(checkboxes)
    this.props.common.setCheckboxes(checkboxes)
  }

  setAllCheckboxes = ({ checked, hooks }) => {
    const checkboxes = { ...this.props.checkboxes }
    hooks.forEach(hook => {
      checkboxes[hook] = checked
        ? Math.pow(2, Object.keys(CHECKBOX[hook]).length) - 1
        : 0
    })
    if (this.props.isLoggedIn)
      this.props.common.saveCheckboxes(checkboxes)
    this.props.common.setCheckboxes(checkboxes)
  }

  handleToggleAdviserFavourite = favouritesEnabled => {
    if (!favouritesEnabled) {
      history.push(`/${PATH.LOGIN}`)
      return
    }
    const adviserId = this.props.match.params.adviserId
    const adviser = this.props.advisersMeta.find(a => a.id === adviserId)
    if (!adviser) return

    const isFavourite = !adviser.isFavourite

    if (adviser.isFavourite) {
      this.props.fav.delete(CATEGORY.COMPANY, adviserId)
    } else {
      const entity = {
        _id: adviserId,
        category: CATEGORY.COMPANY,
        ids: [],
        isFavourite: false,
        name: {
          original: adviser.name,
          toMatch: adviser.name,
          toPresent: adviser.adviserName,
          toSort: adviser.name,
        },
      }
      if (!this.props.features.Developer && wouldExceedMaxCount(entity, this.props.favourites)) {
        this.setState({ showMaxFavouritesReached: true })
        return
      }
      this.props.fav.add({ entity })
    }

    this.props.advisers.setIsFavouriteById(this.props.advisersMeta, adviserId, isFavourite)
  }

  handleToggleClientFavourite = ({ row }) => {
    const { favourites, lseCompaniesMeta, searchResults } = this.props
    const entityId = row.ids?.[0] || row._id
    const isFavourite = !row.isFavourite

    if (row.isFavourite) {
      this.props.fav.delete(CATEGORY.COMPANY, entityId)
    } else {
      const entity = {
        _id: entityId,
        category: CATEGORY.COMPANY,
        ids: row.ids,
        isFavourite: false,
        name: {
          original: row.title,
          toMatch: row.title,
          toPresent: row.title,
          toSort: row.title,
        },
      }
      if (!this.props.features.Developer && wouldExceedMaxCount(entity, favourites)) {
        this.setState({ showMaxFavouritesReached: true })
        return
      }
      this.props.fav.add({ entity })
    }

    this.props.lse.setIsFavouriteById({ lseCompaniesMeta, _id: entityId, isFavourite })
    this.props.search.updateIsFavouriteUsingIds({ searchResults, ids: row.ids, isFavourite })
  }

  render() {
    const adviserId = this.props.match.params.adviserId
    const { advisersMeta, checkboxes, features, lseCompaniesMeta, portrait, rollups, tableOrder, the350club, urlSource } = this.props

    if (!advisersMeta || !lseCompaniesMeta?.items) return null

    const adviser = advisersMeta.find(a => a.id === adviserId)
    if (!adviser) return null

    const titleText = `${adviser.adviserName} - ${JARGON.ADVISER_CLIENT}s`

    const kind = KIND.NEXUS.COMPANY.ADVISER_CLIENTS
    const orderSet = portrait ? TABLE_BIT.PORTRAIT : 0
    const favouritesEnabled = features.Favourites

    const clients = filterAdviserClientsByCheckbox({
      items: findCompaniesUsingAdviser(lseCompaniesMeta.items, adviser.adviserName),
      checkboxes,
    })

    const menuProps = {
      checkboxes,
      features,
      handleChangeCheckbox: this.handleChangeCheckbox,
      handleRollupClick: e => this.props.app.toggleRollup(e),
      kind,
      portrait,
      rollups,
      setAllCheckboxes: this.setAllCheckboxes,
      tabIndex: TAB[BASE.COMPANY].INDEX,
    }

    const tableProps = {
      adviserName: adviser.adviserName,
      clients,
      favouritesEnabled,
      handleClickFavouriteIcon: row => this.handleToggleClientFavourite(row),
      handleOrderTable: props => this.handleOrderTable({ ...props, table: kind, orderSet }),
      handleSelect: this.handleSelect,
      items: lseCompaniesMeta.items,
      kind,
      portrait,
      tableInfo: { page: 0, rowsPerPage: 1000 },
      tableOrder: tableOrder[kind][orderSet],
      the350club,
    }

    const menu = <NexusMenu portrait={portrait}>{getCheckboxMenu(menuProps)}</NexusMenu>

    return (
      <React.Fragment>
        <Navbar />
        <HomePageTabs />

        <TitleBar
          count={clients.length}
          features={features}
          handleOnClickFavourite={this.handleToggleAdviserFavourite}
          isFavourite={adviser.isFavourite ?? false}
          portrait={portrait}
          starIcon={true}
          tabIndex={-1}
          the350club={the350club}
          titleText={titleText}
        />

        <MainSection portrait={portrait} style={{ backgroundColor: CARD.CONTAINER.BACKGROUND_COLOR }}>
          <DataCard portrait={portrait}>
            {!portrait && menu}
            <NexusAdviserClientsTable {...tableProps} />
            {portrait && menu}
          </DataCard>
        </MainSection>

        <Footer urlSource={urlSource} />

        <MaxFavouritesReachedModal
          open={this.state.showMaxFavouritesReached}
          onClose={() => this.setState({ showMaxFavouritesReached: false })}
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ advisers, app, common, fav, lse, news, search, synopsis, user }) => ({
  advisersMeta: advisers.advisers,
  advisersSynced: advisers.synced,
  checkboxes: common.checkboxes,
  companyId: common.companyId,
  features: app.features,
  isLoggedIn: !!app.token,
  favourites: fav.favourites,
  favouritesFetching: fav.isFetching,
  lseCompaniesMeta: lse.companiesMeta,
  lsePeopleMeta: lse.peopleMeta,
  newsId: common.newsId,
  newsMeta: news.meta,
  nexusView: common.nexusView,
  personId: common.personId,
  portrait: user.portrait,
  radio: common.radio,
  rollups: app.rollups,
  searchResults: search.searchResults,
  searchStringObj: common.searchStringObj,
  tableOrder: common.tableOrder,
  the350club: common.the350club,
  urlSource: common.urlSource,
  urlTrialCode: common.urlTrialCode,
})

export default connect(
  mapStateToProps,
  dispatch => ({
    advisers: bindActionCreators(advisersActions, dispatch),
    app: bindActionCreators(appActions, dispatch),
    common: bindActionCreators(commonActions, dispatch),
    fav: bindActionCreators(favActions, dispatch),
    lse: bindActionCreators(lseActions, dispatch),
    news: bindActionCreators(newsActions, dispatch),
    search: bindActionCreators(searchActions, dispatch),
    synopsis: bindActionCreators(synopsisActions, dispatch),
  })
)(AdviserPage)
